import React from "react";
import LoginButton from "./LoginButton";
import ForestAdminLogo from "../../images/forest-admin-logo.png";

// Status Dot
const statusColors = {
  pending: "#f59e0b",
  success: "#10b981",
  error: "#ef4444",
};

const StatusDot = ({ status }) => (
  <span
    style={{
      display: "inline-block",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: statusColors[status] || statusColors.pending,
      flexShrink: 0,
    }}
  />
);

// Info Item Component
const InfoItem = ({ label, children }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
    <span
      style={{
        fontSize: "12px",
        color: "#9ca3af",
        fontWeight: "500",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
      }}
    >
      {label}
    </span>
    {children}
  </div>
);

export default function HeaderProcess({ data }) {
  const accountOwner =
    data.Users && data.Users.find(({ role }) => role === "Account owner");
  const columnCount = data.template_company_id ? 6 : 5;

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "28px",
        marginBottom: "24px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
          gap: "24px",
          alignItems: "start",
        }}
      >
        {/* Name */}
        <InfoItem label="Name">
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <StatusDot status={data.status} />
            <span
              style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}
            >
              {data.company_name}
            </span>
            {data.company_id && (
              <a
                href={`https://app.forestadmin.com/Spendesk/Demo/role/data/Company/index/record/Company/${data.company_id}/summary`}
                target="_blank"
                rel="noreferrer"
                title="Open in Forest Admin"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  color: "#7c3aed",
                  flexShrink: 0,
                }}
              >
                <img
                  src={ForestAdminLogo}
                  alt=""
                  style={{ width: "16px", height: "16px", borderRadius: "3px" }}
                />
              </a>
            )}
          </div>
        </InfoItem>

        {/* Company ID */}
        <InfoItem label="Company ID">
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}
          >
            {data.company_id || "—"}
          </span>
        </InfoItem>

        {/* Currency */}
        <InfoItem label="Currency">
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}
          >
            {data.currency || "—"}
          </span>
        </InfoItem>

        {/* Plan */}
        <InfoItem label="Plan">
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}
          >
            {data.billing_subscription_plan || "—"}
          </span>
        </InfoItem>

        {/* Provider */}
        <InfoItem label="Provider">
          <span
            style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}
          >
            {data.banking_provider
              ? data.banking_provider === "bankable"
                ? "Bankable"
                : "SFS"
              : "—"}
          </span>
        </InfoItem>

        {data.template_company_id && (
          <InfoItem label="Template">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#111827",
                }}
              >
                {data.template_company_name || "—"}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontFamily: "monospace",
                  color: "#9ca3af",
                }}
              >
                {data.template_company_id}
              </span>
            </div>
          </InfoItem>
        )}
      </div>
    </div>
  );
}
